import request from '@/libs/request'

export function articleList (data) {
  return request({
    url: `wechatArticle/list`,
    method: 'get',
    params: data
  })
}

export function sendArticle (id) {
  let data = {mediaId : id}
  return request({
    url: `wechatArticle/sendArticle`,
    method: 'post',
    data: data
  })
}
